import axios from "axios/dist/axios";
const typedAxios = axios;
export function setAxiosAuthToken(token) {
    typedAxios.defaults.headers.common.Authorization = `Bearer ${token}`;
}
;
export function clearAxiosAuthToken() {
    delete typedAxios.defaults.headers.common.Authorization;
}
export default typedAxios;
